import { getCloudinaryConfig } from '../config/cloudinary';

export const generateSignature = async (timestamp: number): Promise<string> => {
  const { apiSecret } = getCloudinaryConfig();
  const str = `timestamp=${timestamp}${apiSecret}`;
  // Use the same signature generation method as the API route
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hash = await crypto.subtle.digest('SHA-1', data);
  const hex = Array.from(new Uint8Array(hash))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
  return hex;
}; 